export default __webpack_public_path__ + "static/media/image01.9026f72f.jpg";